<template>
	<div class="userinfos">
		<div style="display: flex;">
			<div style="color: #333;font-size: 14px;">头像：</div>
			<el-upload
			  class="avatar-uploader"
			  action
			  ref="uploadPag"
			  :limit="1"
			  accept="image/png, image/gif, image/jpg, image/jpeg"
			  :on-change="uploadChange"
			  :on-preview="handlePictureCardPreview"
			  :on-remove="handleRemove"
			  :auto-upload="false"
			  :file-list="fileList"
			  :show-file-list="false"
			 >
			  <img v-if="headimgurl" :src="headimgurl" class="avatar">
			  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		</div>
		<div style="display: flex;align-items: center;margin-top: 20px;">
			<div style="color: #333;font-size: 14px;">昵称：</div>
			<el-input placeholder="请输入昵称" v-model="$store.state.user.nickname" style="width: 300px;"></el-input>
		</div>
		<el-button type="primary" style="margin-top: 30px;" @click="user_save_info">立即保存</el-button>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { uploadOss } from "@/api/config"
	import { user_save_info } from "@/api/user"
	export default {
		data(){
			return{
				fileList:[],
				
			}
		},
		computed: mapGetters([
			"nickname","headimgurl","token"
		]),
		watch:{

		},
		methods:{
			user_save_info(){
				if(!this.$store.state.user.headimgurl || !this.$store.state.user.nickname){
					this.$message.error("头像或昵称不能为空");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '更新中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				user_save_info({
					headimgurl:this.$store.state.user.headimgurl,
					nickname:this.$store.state.user.nickname
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
					this.$store.dispatch('user/getInfo');
				}).catch(()=>{
					loading.close();
				})
			},
			async uploadChange(file,fileList) {
			  let that = this;
			  if(that.$refs.uploadPag.uploadFiles.length>1){
				  that.$refs.uploadPag.uploadFiles.shift();
			  }
			  const isIMAGE =
			    file.raw.type === "image/jpeg" ||
			    file.raw.type === "image/png" ||
			    file.raw.type === "image/jpg" ||
			    file.raw.type === "image/gif";
			  /*var isIMAGE = /^image\/(jpeg|png|jpg|gif)$/.test(file.type);*/
			  const isLt5M = file.size / 1024 / 1024 < 5;
			
			  if (!isIMAGE) {
			    this.$message.error("上传文件只能是图片格式!");
			    return false;
			  }
			  if (!isLt5M) {
			    this.$message.error("上传文件大小不能超过 5MB!");
			    return false;
			  }
					console.log(file.raw);
			   const loading = this.$loading({
				lock: true,
				text: '上传中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			  });
			  let formData =new FormData();
			  formData.append("file", file.raw)
			  that.$refs.uploadPag.clearFiles();
			  await uploadOss(formData).then(res=>{
				  loading.close();
				  that.$message.success("上传成功");
				  console.log(res)
				  that.$refs.uploadPag.clearFiles();
				  that.$store.state.user.headimgurl = res.data
			  }).catch(()=>{
				  that.$refs.uploadPag.clearFiles();
				  loading.close();
			  })
			  //this.$emit("upload", file.raw);
			},
			handleRemove(file, fileList) {
			  console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
			 
			},
		},
	}
</script>

<style lang="scss">
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
	.userinfos{
		width: 100%;
		margin-top: 20px;
		
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/new/user.vue